import React, { useState } from 'react'
import Page from '../../common/Page'
import Card from '../../common/Card'
import $t from 'i18n'
import { validateDOB } from 'utils/validations'
import { isEmpty } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import MemberInfo from '../../common/MemberInfo'
import { Button } from 'antd'
import Actions from '../../../actions'
import { relationship } from 'consts'
import { STEPS } from 'consts/flowConsts'
import { scrollToError } from 'utils/generalUtils'

import './Info.css'

const getValidationErrors = (ageRequirments, { dob, sex, relation }) => {
  const result = {}

  const isOwner = relation === relationship.owner
  const dobValidation = validateDOB(ageRequirments, dob, relation)
  if (!dobValidation.isValid) {
    result.dob = dobValidation.error
  }
  if (!sex) {
    result.sex = $t('errors.validation.missingSex')
  }
  if (!isOwner && !relation) {
    result.relation = $t('errors.validation.missing')
  }

  return (!isEmpty(result) && result) || null
}

const Info = () => {
  const dispatch = useDispatch()
  const ageRequirments = useSelector(
    state => state.app.appConfig?.age_limitations
  )

  const members = useSelector(state => state.member?.members)

  const [shouldValidate, setShouldValidate] = useState(false)

  const memberErrors =
    shouldValidate &&
    members?.map(member => getValidationErrors(ageRequirments, { ...member }))

  const MAX_FAMILY_MEMBERS = 20

  const onProceed = () => {
    const errors = members?.map(member =>
      getValidationErrors(ageRequirments, { ...member })
    )
    if (errors?.some(error => error)) {
      setShouldValidate(true)
      scrollToError()
      return
    }
    setShouldValidate(false)

    //proceed to next step
    dispatch(
      Actions.createAction(Actions.STEP_COMPLETED, {
        step: STEPS.INFO
      })
    )
  }

  const onAddFamily = () => {
    dispatch(Actions.createAction(Actions.ADD_MEMBER))
  }

  const onMemberChanged = (key, value, id) => {
    dispatch(
      Actions.createAction(Actions.MEMBER_INFO_CHANGED, { key, value, id })
    )
  }

  return (
    <Page
      className='enroll-info'
      title={$t('enroll.info.title')}
      backImage={'back_image_info.svg'}
      canNavigateBack={false}
      canSkip={true}
    >
      {members?.map((member, index) => (
        <Card className='member-card' key={member?.id}>
          <MemberInfo
            member={member}
            errors={memberErrors?.[index]}
            onChange={(key, value) => onMemberChanged(key, value, member?.id)}
          />
        </Card>
      ))}
      <div className='enroll-info-actions'>
        {
          // The max number of family members is 20, owner is one, so we can add until 21
          members?.length <= MAX_FAMILY_MEMBERS + 1 && (
            <Button
              className='add-family-btn trackable'
              data-name='add-member'
              onClick={onAddFamily}
            >
              {$t('enroll.info.addMember')}
            </Button>
          )
        }
        <Button
          className='see-plans-btn trackable'
          data-name='see-plans-and-prices'
          type='primary'
          onClick={onProceed}
        >
          {$t('enroll.info.submit')}
        </Button>
      </div>
    </Page>
  )
}

export default Info
